import { Link } from "react-router-dom";

export default function AuthLayout({ children }) {
  return (
    <div className="relative z-10 min-h-screen flex flex-col" data-testid="auth-page">
      <header className="px-5 sm:px-10 py-5">
        <Link to="/" data-testid="header-logo" className="font-display text-2xl font-extrabold text-[#2E6F40]">
          Svuota<span className="text-[#D95338]">Frigo</span>
        </Link>
      </header>
      <div className="flex-1 flex items-center justify-center px-4 pb-12">{children}</div>
    </div>
  );
}
